<script lang="ts" setup>
import Checkbox from "~/components/ui/Form/Checkbox.vue";
import t from "~/utils/translate";
import SwipeBetHandTap from "./SwipeBetHandTap.vue";
import SwipeBetHandSwipe from "./SwipeBetHandSwipe.vue";
const dontShowAgain = ref(false);
const swipeTutorialCookie = useCookie("swipe_hide_tutorial", {
	default: () => false,
});
const showTutorial = ref(!swipeTutorialCookie.value);
const closeTutorial = () => {
	if (dontShowAgain.value === true) {
		swipeTutorialCookie.value = true;
	}
	showTutorial.value = false;
};
</script>
<template>
	<div class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full opacity-90 bg-dark-900" v-if="showTutorial">
		<div class="grid w-full max-w-sm grid-cols-3 gap-2 px-4 grid-rows-12 md:grid-cols-7 md:gap-4 md:max-w-none md:px-0">
			<div class="flex flex-col items-center justify-center col-start-2 row-start-1 md:col-start-4">
				<div class="flex flex-col items-center jusitfy-center">
					<span class="text-sm text-light-50">{{ t("swipe-bet-welcome-1") }}</span>
					<div class="mt-2 text-5xl font-bold"><span class="text-light-50">SWIPE</span><span class="text-primary-500">BET</span></div>
				</div>
			</div>

			<div class="flex items-center justify-center col-start-1 row-start-4 md:col-start-3">
				<div class="mb-2 mr-3 text-xs leading-5 text-right text-light-50">
					<b class="text-sm">{{ t("swipe-left") }}</b> <br />
					{{ t("to-pass-on-offer") }}
				</div>
			</div>
			<div class="flex items-center justify-center col-start-2 row-start-4 mt-4 md:col-start-4">
				<SwipeBetHandSwipe />
			</div>
			<div class="flex items-center justify-center col-start-3 row-start-4 md:col-start-5">
				<div class="mb-2 ml-3 text-xs leading-5 text-left text-light-50">
					<b class="text-sm">{{ t("swipe-right") }}</b> <br />
					<span class="capitalize">{{ t("to") }} &nbsp;</span><span class="font-bold text-primary-500"> {{ t("add-to-betslip") }}</span>
				</div>
			</div>

			<div class="flex items-center justify-center col-start-1 row-start-6 md:col-start-3">
				<div class="mb-2 mr-3 text-xs leading-5 text-right text-light-50">
					<b class="text-sm">{{ t("tap-left") }}</b> <br />
					{{ t("to-change-market") }}
				</div>
			</div>
			<div class="flex items-center justify-center col-start-2 row-start-6 mt-4 md:col-start-4">
				<SwipeBetHandTap />
			</div>
			<div class="flex items-center justify-center col-start-3 row-start-6 md:col-start-5">
				<div class="mb-2 ml-3 text-xs leading-5 text-left text-light-50">
					<b class="text-sm">{{ t("tap-right") }}</b> <br />
					{{ t("to-change-market") }}
				</div>
			</div>

			<div class="flex flex-col items-center justify-center col-span-3 col-start-1 row-start-7 md:col-start-4 md:col-span-1">
				<div class="flex flex-col items-center w-full mt-10 jusitfy-center">
					<UiButton @click="closeTutorial()" :label="t('continue')" class="w-full cursor-pointer md:w-auto bg-primary-600 hover:bg-primary-700" />
					<div class="mt-2">
						<Checkbox
							class="mt-4 cursor-pointer"
							:label="t('dont-show-again')"
							:display-label="true"
							labelStyle="text-light-50 text-xs font-light leading-4 cursor-pointer select-none"
							v-model="dontShowAgain"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
